import { ReactNode } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";
import { applyBreakpoint } from "~/utils/Helpers";

const FONT_SIZE_CLASSES = {
    "xl": "text-[51px]",
    "lg": "text-[43px]",
    "md": "text-[36px]",
    "sm": "text-[28px]",
    "xs": "text-[20px]",
} as const;

const leadVariants = cva("", {
    variants: {
        font: {
            "suisseBP": "font-suisseBP",
            "itemsText": "font-itemsText",
            "featureDisplay": "font-featureDisplay",
        },
        size: FONT_SIZE_CLASSES,
    },
    defaultVariants: {
        font: "suisseBP",
        size: "lg",
    },
});

type ResponsiveSize = {
    sm?: VariantProps<typeof leadVariants>["size"];
    md?: VariantProps<typeof leadVariants>["size"];
    lg?: VariantProps<typeof leadVariants>["size"];
    xl?: VariantProps<typeof leadVariants>["size"];
};

type Props = VariantProps<typeof leadVariants> & {
    children: ReactNode;
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "sub" | "sup" | "i" | "em";
    className?: string;
    sizes?: ResponsiveSize;
}

export const Lead = ({ children, as: Tag = "p", className, size, sizes = {}, font }: Props) => {
    const responsiveClasses = Object.entries(sizes).map(([bp, variant]) => {
        return applyBreakpoint(bp, [FONT_SIZE_CLASSES[variant!]]);
    }).join(" ");

    return (
        <Tag className={cn(leadVariants({ className, size, font }), responsiveClasses, "leading-[1.2]")}>{children}</Tag>
    );
};

export default Lead;